import React, { useState } from 'react';
import { NotificationCard } from './NotificationCard';
import { IFirestoreAlert } from '../../../../Types/firestoreTypes';
import { formatTime } from '../../../../utils/formatters';
import { handleAlertNavigation } from '../../../../utils/navigationHelpers';
import { useJobAlertCopy } from '../../../../hooks/useJobAlertCopy';

interface AlertNotificationProps {
  alert: IFirestoreAlert;
  alertId: string;
  onDismiss: (alertId: string, visibility: 'ACKNOWLEDGED' | 'DISMISSED') => void;
  onClose: () => void;
}

const AlertNotification: React.FC<AlertNotificationProps> = ({ alert, alertId, onDismiss }) => {
  const [isDismissing, setIsDismissing] = useState(false);
  const copy = useJobAlertCopy(alert);
  const handleDismiss = async (visibility: 'ACKNOWLEDGED' | 'DISMISSED' = 'DISMISSED') => {
    setIsDismissing(true);
    try {
      await onDismiss(alertId, visibility);
    } catch (error) {
      console.error('Error dismissing alert:', error);
      setIsDismissing(false);
    }
  };

  const handleAlertClick = async () => {
    if (!alert.linkAction) return;
    await handleDismiss('ACKNOWLEDGED');
    handleAlertNavigation(alert.linkAction, { alertType: alert.type });
  };

  const getAlertIcon = () => {
    switch (alert.type) {
      case 'CONTACT_READY':
        return <i className="fa-duotone fa-solid fa-user"></i>;
      case 'ACTION_READY':
        return <i className="fa-duotone fa-solid fa-bolt"></i>;
      case 'SOCIAL_PROMPT_PREFERENCE_SUGGESTION':
        return <i className="fa-duotone fa-solid fa-wand-magic-sparkles"></i>;
      default:
        return <i className="fa-duotone fa-solid fa-info-circle"></i>;
    }
  };

  const getAlertTypeClass = (): 'alert-contact' | 'alert-action' | 'alert-default' => {
    switch (alert.type) {
      case 'CONTACT_READY':
        return 'alert-contact';
      case 'ACTION_READY':
        return 'alert-action';
      case 'SOCIAL_PROMPT_PREFERENCE_SUGGESTION':
        return 'alert-action';
      default:
        return 'alert-default';
    }
  };



  return (
    <NotificationCard
      title={copy.title}
      description={copy.description}
      icon={getAlertIcon()}
      variant={getAlertTypeClass()}
      time={formatTime(alert.createdAt)}
      action={alert.linkAction?.link_type === 'JOB'
        ? <button type="button" className="alert-review" onClick={event => { event.stopPropagation(); void handleAlertClick(); }}>View results</button>
        : alert.type === 'DISMISSAL_AUTOMATION' && <span>Review change</span>}
      onClick={alert.linkAction ? handleAlertClick : undefined}
      onDismiss={() => onDismiss(alertId, 'DISMISSED')}
      busy={isDismissing}
    />
  );
};

export default AlertNotification;
